<template>
	<section class="footer-modal">
		<div class="footer-container">
			<v-btn
				class="btn-action caption mr-1"
				color="pink"
				:disabled="onRunService"
				v-if="!hidden"
				@click="cancelModal"
			>
				Cancelar
				<img
					class="ml-2"
					:src="`${$imageUrl}/icon-cancel.svg`"
					alt=""
				>
			</v-btn>
			<v-btn
				class="btn-action caption ml-1"
				:color="successColor"
				:disabled="isLoading"
				v-if="!hiddenSaveBtn"
				@click="setInfo"
			>
				{{ successText }}
				<img
					class="ml-2"
					:src="`${$imageUrl}/${successImg}`"
					alt="">
			</v-btn>
			<slot></slot>
		</div>
	</section>
</template>

<script>

function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

export default {
	name: 'modal-sidebar-button',
	methods: {
		cancelModal,
		setInfo,
	},
	props: {
		isLoading: {
			default: true,
			type: Boolean,
		},
		hidden: {
			type: Boolean,
			default: false,
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false,
		},
		onRunService: {
			default: false,
			type: Boolean,
		},
		successColor: {
			default: 'success',
			type: String,
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String,
		},
		successText: {
			default: 'Aceptar',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.footer-modal {
	border: 1px solid map-get($colors, grey);
	height: 9vh;
	width: 100%;
	.footer-container {
		@include flex-center;
		height: 100%;
		.btn {
			border-radius: 5px;
			color: white;
			height: 30px;
			width: 97px;
		}
		.cancel {
			background-color: map-get($colors, error);
		}
		.send {
			background-color: map-get($colors, success);
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/shared/utils/modal-sidebar-button.vue